mutation RemoveAttachmentsFromAttachmentAlbum($ids: [ID!]!, $albumId: ID!) {
  removeAttachmentsFromAttachmentAlbum(
    attachmentIds: $ids
    attachmentAlbumId: $albumId
  ) {
    success
    errors
  }
}
